import { dew as _rewriteStackTrace2Dew } from "./rewrite-stack-trace";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _rewriteStackTrace = _rewriteStackTrace2Dew();
  class ConfigError extends Error {
    constructor(message, filename) {
      super(message);
      (0, _rewriteStackTrace.expectedError)(this);
      if (filename) (0, _rewriteStackTrace.injectVirtualStackFrame)(this, filename);
    }
  }
  exports.default = ConfigError;
  0 && 0;

  //# sourceMappingURL=config-error.js.map
  return exports;
}